import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white border-t border-gray-100 py-12">
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start space-y-8 md:space-y-0">
          
          {/* Logo / Copyright */}
          <div className="text-center md:text-left">
            <img src="/assets/images/logo.png" alt="Logo" className="h-6 mb-4 mx-auto md:mx-0 opacity-80" />
            <p className="text-xs text-gray-400">© 2026 wkarchitectures. All rights reserved.</p>
          </div>

          {/* Nav */}
          <div className="flex space-x-6 text-sm font-medium">
            <a href="#projects" className="hover:opacity-60">{t('nav.projects')}</a>
            <a href="#agency" className="hover:opacity-60">{t('nav.agency')}</a>
            <a href="#contact" className="hover:opacity-60">{t('nav.contact')}</a>
          </div>

          {/* Legal */}
          <div className="flex space-x-4 text-xs text-gray-400">
            <a href="#" className="hover:text-black">{t('footer.legal')}</a>
            <a href="#" className="hover:text-black">{t('footer.privacy')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
